import {$authHost, $host} from "./index";
import {
    ORDERS,
    ORDERS_ADMIN,
    ORDERS_ADMIN_ID,
    ORDERS_ADMIN_STATS,
    ORDERS_ID,
    ORDERS_STATUSES,
} from "./ApiEndpoints";

const GUEST_ORDER_IDS_KEY = 'orders';

function rememberGuestOrderId(id) {
    const list = JSON.parse(localStorage.getItem(GUEST_ORDER_IDS_KEY) || '[]');
    const sid = String(id);
    if (!list.includes(sid)) {
        list.push(sid);
        localStorage.setItem(GUEST_ORDER_IDS_KEY, JSON.stringify(list));
    }
}

/**
 * Заказы пользователя: { orders, currentPage, pageSize, totalElements, totalPages, first, last }.
 * Параметры: page, size, sort, status.
 */
export const fetchOrders = async (params = {}) => {
    const {data} = await $authHost.get(ORDERS, {params});
    return data;
}

/**
 * Админ: список заказов с тем же форматом страницы + фильтры query (номер, email, имя, телефон), status, userId, minPrice, maxPrice, startDate, endDate (ISO-8601 LocalDateTime).
 */
export const fetchOrdersAdmin = async (params = {}) => {
    const {data} = await $authHost.get(ORDERS_ADMIN, {params});
    return data;
}

/**
 * Админ: агрегированная статистика заказов за период.
 * Параметры: startDate, endDate (ISO-8601 LocalDateTime, обе границы опциональны).
 * Возвращает: {totalOrders, totalRevenue, pendingOrders, startDate, endDate}.
 */
export const fetchOrdersStats = async (params = {}) => {
    const {data} = await $authHost.get(ORDERS_ADMIN_STATS, {params});
    return data;
}

/**
 * Заказ: с JWT — свой заказ; без JWT — гостевой по UUID (бэк отдаёт только guest или 403 для чужого user-order).
 */
export const fetchOrderById = async (id, isAuth) => {
    const client = isAuth ? $authHost : $host;
    const {data} = await client.get(ORDERS_ID + id);
    return data;
}

/**
 * @param {object} body
 * @param {object} body.shipmentRequest — контакты и адрес; без суммы доставки (она не часть профиля shipment).
 * @param {Array<{itemId:number, itemCount:number}>} body.orderItemRequests — для гостя; для авторизованного []
 * @param {'MANUAL'|'YANDEX_PICKUP'} body.deliveryType
 * @param {number|null|undefined} body.deliveryFee — при YANDEX_PICKUP: сумма из расчёта виджета → сохраняется в заказе (order.deliveryFee)
 * @param {string|null|undefined} body.yandexPickupPointId
 * @param {boolean} isAuth
 */
export const createNewOrder = async (body, isAuth) => {
    const payload = {
        shipmentRequest: body.shipmentRequest,
        orderItemRequests: body.orderItemRequests || [],
        deliveryType: body.deliveryType || 'MANUAL',
        deliveryFee: body.deliveryFee != null ? body.deliveryFee : null,
        yandexPickupPointId: body.yandexPickupPointId || null,
    };
    if (isAuth) {
        const {data} = await $authHost.post(ORDERS, payload);
        return data;
    }
    const {data} = await $host.post(ORDERS, payload);
    rememberGuestOrderId(data.id);
    return data;
}

export const payForOrder = async (id, isAuth) => {
    const client = isAuth ? $authHost : $host;
    const response = await client.post(ORDERS_ID + id);

    if (response.status === 201) {
        window.open(response.data, '_blank');
    }
    return response.data;
}

export const checkOrderPayment = async (id, isAuth) => {
    const client = isAuth ? $authHost : $host;
    const {data} = await client.put(ORDERS_ID + id);
    return data;
}

export const checkOrderPaymentAdmin = async (id) => {
    const {data} = await $authHost.put(ORDERS_ADMIN_ID + id, null);
    return data;
}

export const fetchOrderByIdAdmin = async (id) => {
    const {data} = await $authHost.get(ORDERS_ADMIN_ID + id);
    return data;
}

export const setOrderStatus = async (id, status) => {
    const {data} = await $authHost.patch(ORDERS_ADMIN_ID + id, {status});
    return data;
}

export const getOrderStatuses = async () => {
    const {data} = await $authHost.get(ORDERS_STATUSES);
    return data;
}

export const cancelOrder = async (id, isAuth) => {
    const client = isAuth ? $authHost : $host;
    const {data} = await client.delete(ORDERS_ID + id);
    return data;
}

export const cancelOrderAdmin = async (id) => {
    const {data} = await $authHost.delete(ORDERS_ADMIN_ID + id);
    return data;
}
